/**
 * Hiérarchie des onglets - source de vérité pour :
 * - Sidebar (menus niveau 1)
 * - BPM Tabs (sous-onglets dans chaque page)
 * - Accès autorisés (popup création/modification utilisateurs)
 *
 * Structure : menus sidebar → onglets BPM à l'intérieur de chaque menu
 */
export const registerDefaultTabs = (tabRegistry) => {
  const { registerTabs } = tabRegistry;

  registerTabs([
    // === MENUS SIDEBAR (niveau 1) ===
    {
      id: 'accueil',
      label: 'Accueil',
      parent: null,
      level: 1,
      children: ['accueil-vue-ensemble', 'accueil-performance', 'accueil-repartition']
    },
    {
      id: 'portefeuille',
      label: 'Portefeuille',
      parent: null,
      level: 1,
      children: ['portefeuille-synthese', 'portefeuille-detail', 'portefeuille-performance', 'portefeuille-volatilite', 'portefeuille-sentiment', 'portefeuille-ordres', 'portefeuille-valorisation']
    },
    {
      id: 'compte',
      label: 'Compte',
      parent: null,
      level: 1,
      children: ['compte-performance', 'compte-synthese-tri', 'compte-apports-retraits', 'compte-investisseurs', 'compte-valorisations', 'compte-commentaires']
    },
    {
      id: 'stock-screener',
      label: 'Stock screener',
      parent: null,
      level: 1,
      children: ['stock-screener-recherche', 'stock-screener-filtres', 'stock-screener-resultats']
    },
    {
      id: 'analyse',
      label: 'Analyse',
      parent: null,
      level: 1,
      children: ['analyse-analyse', 'analyse-feed-x', 'analyse-import', 'analyse-parametres']
    },
    {
      id: 'macro',
      label: 'Macro',
      parent: null,
      level: 1,
      children: ['macro-indices', 'macro-matieres-premieres', 'macro-macro', 'macro-historique-120-ans']
    },
    {
      id: 'ai',
      label: 'Oliver',
      parent: null,
      level: 1,
      children: ['ai-chat']
    },
    {
      id: 'parametres',
      label: 'Paramètres',
      parent: null,
      level: 1,
      children: ['compte-settings', 'configuration', 'apparence', 'valeurs-par-defaut', 'api', 'import-export', 'utilisateurs', 'administration', 'configuration-admin', 'statuts', 'logs']
    },
    // === Accueil > BPM tabs (niveau 2) ===
    { id: 'accueil-vue-ensemble', label: "Vue d'ensemble", parent: 'accueil', level: 2 },
    { id: 'accueil-performance', label: 'Performance', parent: 'accueil', level: 2 },
    { id: 'accueil-repartition', label: 'Répartition', parent: 'accueil', level: 2 },
    // === Portefeuille > BPM tabs (niveau 2) ===
    { id: 'portefeuille-synthese', label: 'Synthèse', parent: 'portefeuille', level: 2 },
    { id: 'portefeuille-detail', label: 'Portefeuille', parent: 'portefeuille', level: 2 },
    { id: 'portefeuille-performance', label: 'Performance', parent: 'portefeuille', level: 2 },
    { id: 'portefeuille-volatilite', label: 'Volatilité', parent: 'portefeuille', level: 2 },
    { id: 'portefeuille-sentiment', label: 'Sentiment', parent: 'portefeuille', level: 2 },
    { id: 'portefeuille-ordres', label: 'Ordres', parent: 'portefeuille', level: 2 },
    { id: 'portefeuille-valorisation', label: 'Valorisation', parent: 'portefeuille', level: 2 },
    // === Compte > BPM tabs (niveau 2) ===
    { id: 'compte-performance', label: 'Performance', parent: 'compte', level: 2 },
    { id: 'compte-synthese-tri', label: 'TRI', parent: 'compte', level: 2 },
    { id: 'compte-apports-retraits', label: 'Apports/Retraits', parent: 'compte', level: 2 },
    { id: 'compte-investisseurs', label: 'Investisseurs', parent: 'compte', level: 2 },
    { id: 'compte-valorisations', label: 'Valorisations', parent: 'compte', level: 2 },
    { id: 'compte-commentaires', label: 'Commentaires', parent: 'compte', level: 2 },
    // === Stock screener > BPM tabs (niveau 2) ===
    { id: 'stock-screener-recherche', label: 'Recherche', parent: 'stock-screener', level: 2 },
    { id: 'stock-screener-filtres', label: 'Filtres', parent: 'stock-screener', level: 2 },
    { id: 'stock-screener-resultats', label: 'Résultats', parent: 'stock-screener', level: 2 },
    // === Analyse > BPM tabs (niveau 2) ===
    { id: 'analyse-analyse', label: 'Analyse', parent: 'analyse', level: 2 },
    { id: 'analyse-feed-x', label: 'Feed', parent: 'analyse', level: 2 },
    { id: 'analyse-import', label: 'Import', parent: 'analyse', level: 2 },
    { id: 'analyse-export', label: 'Export', parent: 'analyse', level: 2 },
    { id: 'analyse-parametres', label: 'Paramètres', parent: 'analyse', level: 2 },
    // === Macro > BPM tabs (niveau 2) ===
    { id: 'macro-indices', label: 'Indices', parent: 'macro', level: 2 },
    { id: 'macro-matieres-premieres', label: 'Matières Premières', parent: 'macro', level: 2 },
    { id: 'macro-macro', label: 'Macro', parent: 'macro', level: 2 },
    { id: 'macro-historique-120-ans', label: 'Historique 120 ans', parent: 'macro', level: 2 },
    // === Oliver > BPM tabs (niveau 2) ===
    { id: 'ai-chat', label: 'Chat Oliver', parent: 'ai', level: 2 },
    // === Paramètres > BPM tabs (niveau 2) ===
    { id: 'compte-settings', label: 'Profil', parent: 'parametres', level: 2 },
    { id: 'configuration', label: 'Configuration', parent: 'parametres', level: 2 },
    { id: 'apparence', label: 'Apparence', parent: 'parametres', level: 2 },
    { id: 'valeurs-par-defaut', label: 'Valeurs par défaut', parent: 'parametres', level: 2 },
    { id: 'api', label: 'API', parent: 'parametres', level: 2 },
    { id: 'import-export', label: 'Import/Export', parent: 'parametres', level: 2 },
    { id: 'utilisateurs', label: 'Utilisateurs', parent: 'parametres', level: 2 },
    { id: 'administration', label: 'Administration', parent: 'parametres', level: 2 },
    { id: 'configuration-admin', label: 'Paramètres généraux', parent: 'parametres', level: 2 },
    { id: 'statuts', label: 'Statuts', parent: 'parametres', level: 2 },
    { id: 'logs', label: 'Logs', parent: 'parametres', level: 2 }
  ]);
};





